export default __webpack_public_path__ + "static/media/Rare.e0e2e05e.svg";